import { motion } from 'framer-motion';
import GearIcon from './logo/GearIcon';
import CircuitLines from './logo/CircuitLines';
import ParticleEffect from './logo/ParticleEffect';

export default function AnimatedLogo() {
  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative w-80 h-80" // Increased from w-48 h-48 (67% larger)
      >
        <GearIcon />
        <CircuitLines />
        <ParticleEffect />
      </motion.div>
    </div>
  );
}